import { render, staticRenderFns } from "./NewProjectControlButtons.vue?vue&type=template&id=ca0343da&scoped=true"
import script from "./NewProjectControlButtons.vue?vue&type=script&lang=js"
export * from "./NewProjectControlButtons.vue?vue&type=script&lang=js"
import style0 from "./NewProjectControlButtons.vue?vue&type=style&index=0&id=ca0343da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca0343da",
  null
  
)

export default component.exports